'use client';
import styled from 'styled-components';
import { theme } from '@/components/features/theme/theme';

const Prev = ({background, color, hoverBackground, hoverColor,id}) => {
    return (
        <StyledHamPrev hoverColor={hoverColor} className="menu-hamburger" id={`${id ? id :'prev-button'}`}>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 40 0)" fill={background ? background :'white'} />
                <circle className={'hover-circle'} cx="20" cy="20" r="0" transform="matrix(-1 0 0 1 40 0)" fill={hoverBackground ? hoverBackground : '#ED2024'} />
                <path d="M26 19C26.5523 19 27 19.4477 27 20C27 20.5523 26.5523 21 26 21V19ZM13.2929 20.7071C12.9024 20.3166 12.9024 19.6834 13.2929 19.2929L19.6569 12.9289C20.0474 12.5384 20.6805 12.5384 21.0711 12.9289C21.4616 13.3195 21.4616 13.9526 21.0711 14.3431L15.4142 20L21.0711 25.6569C21.4616 26.0474 21.4616 26.6805 21.0711 27.0711C20.6805 27.4616 20.0474 27.4616 19.6569 27.0711L13.2929 20.7071ZM26 21H14V19H26V21Z" fill={color ? color :'#152637'} />
            </svg>

        </StyledHamPrev>
    );
};
const StyledHamPrev = styled.div`
    cursor: pointer;
    transition: ${theme.transition};
    height: 40px;
    width: 40px;
    display: inline-block;

    svg {
        height: 40px;
        width: 40px;

        path {
            transition: ${theme.transition};

        }

        circle {
            transition: ${theme.transition};
        }
    }

    &:hover {
        svg {
            .hover-circle{
                r:20px;
            }
            path {
                fill: ${props => props.hoverColor || theme.colors.white};
                transform: translateX(-2px);
            }
        }
    }

`
export default Prev;